import $ from 'jquery'

import { SfLog } from '@app/adapters/logger'
import { collapsedGroupsStorageKey } from '@app/application/workflows/constants'
export default class ToggleAccountGroup {
  constructor(accountList, filterContainer) {
    this.accountList = accountList
    this.filterContainer = filterContainer
    this.toggleFilter = this.filterContainer.find(
      '[data-behaviour~="workflow-account-toggle-filter"]'
    )
    const workingScreen = $(accountList).parent()
    this.storeKey = collapsedGroupsStorageKey(
      workingScreen.data('workflow-id'),
      workingScreen.data('report-id')
    )
    this.attachEvents()
  }

  attachEvents() {
    this.accountList.on(
      'click',
      '[data-behaviour~="account-group-indicator"]',
      (e) => {
        const $target = $(e.target).closest(
          'td[data-behaviour~="account-group-indicator"]'
        )
        this.handleGroupToggle($target)
      }
    )
    const collapsed = window.localStorage.getItem(this.storeKey)
    let groupIds
    try {
      groupIds = JSON.parse(collapsed)
    } catch (e) {
      SfLog.error('Error parsing collapsed groups', {
        error: e,
      })
    }

    if (groupIds) {
      this.showAllRows()

      groupIds.forEach((groupId) => {
        const $target = this.accountList.find(`[data-group-id="${groupId}"]`)
        const $targetParent = $target.closest(
          'tr[data-behaviour~="account-list-item"]'
        )
        if ($target.length && $targetParent.length) {
          this.hideGroup($target, $targetParent)
        }
      })
    }

    this.toggleFilter.on('SHOW_ALL_ROWS', () => {
      this.showAllRows()
    })
  }

  handleGroupToggle($target) {
    const $targetParent = $target.closest(
      'tr[data-behaviour~="account-list-item"]'
    )

    const isGroupCollapsed = $targetParent.attr('data-group-collapsed')

    if (!isGroupCollapsed || isGroupCollapsed === 'false') {
      this.hideGroup($target, $targetParent)
    } else {
      $target
        .find('.fa')
        .addClass('fa-chevron-down')
        .removeClass('fa-chevron-right')

      $targetParent.attr('data-group-collapsed', 'false')

      this.showGroupChildren(this.findGroupChildren($targetParent))
    }
    const collapsed = []
    const time = new Date()
    this.accountList
      .find('[data-group-collapsed="true"]')
      .each(function (_, el) {
        collapsed.push($(el).data('groupId'))
      })
    window.localStorage.setItem(this.storeKey, JSON.stringify(collapsed))
    window.localStorage.setItem(`${this.storeKey}.updatedAt`, time.toJSON())

    this.toggleFilter.trigger('REFILTER')
  }

  showGroupChildren = (groupChildren) => {
    groupChildren.removeAttr('data-row-hidden').show()

    // If collapsed group contains another collapsed sub-groups, we want to keep them invisible
    this.hideNestedGroups(groupChildren)
  }

  hideGroup($target, $targetParent) {
    $target
      .find('.fa')
      .removeClass('fa-chevron-down')
      .addClass('fa-chevron-right')

    $targetParent.attr('data-group-collapsed', 'true')

    this.hideGroupChildren($targetParent)
  }

  hideGroupChildren($targetParent) {
    this.findGroupChildren($targetParent).attr('data-row-hidden', 'true').hide()
  }

  findGroupChildren($parent) {
    let nextEqualGroupFound = false
    const parentLevel = $parent.data('level')

    return $parent
      .nextAll("tr[data-behaviour~='account-list-item']")
      .filter((index, el) => {
        if (!nextEqualGroupFound && $(el).data('level') > parentLevel) {
          return true
        } else {
          nextEqualGroupFound = true
          return false
        }
      })
  }

  hideNestedGroups = (groupChildren) => {
    groupChildren
      .filter((_, el) => $(el).attr('data-group-collapsed') === 'true')
      .each((_, child) => {
        const $child = $(child)

        this.hideGroupChildren($child)
      })
  }

  showAllRows = () => {
    this.accountList
      .find('tr[data-behaviour~="account-list-item"]')
      .removeAttr('data-group-collapsed')
      .removeAttr('data-row-hidden')
      .show()

    this.accountList
      .find(
        'tr[data-behaviour~="account-list-item"] td[data-behaviour~="account-group-indicator"] .icon'
      )
      .addClass('fa-chevron-down')
      .removeClass('fa-chevron-right')
  }
}
